import api from 'services/api'


export const fetchGlobalConfig = () =>
  api.get(`/configuration`)

export const editGlobalConfig = ({carrierVerificationValidityAfterDischarge, carrierEmailsNumber}) =>
  api.patch(`/configuration`, {carrierVerificationValidityAfterDischarge, carrierEmailsNumber})
